export default __webpack_public_path__ + "locales/pt-BR/JavascriptSdk.json?hash=680a7e9c6cf896edaa2cf49aa57589f1";